import React, { useRef } from 'react';
import { ACCEPTED_IMAGE_EXTENSIONS, validateImageFile } from '../../utils/imageUtils';

function ImageUpload({ label, preview, onChange, error }) {
  const inputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0] || null;
    onChange(file);
  };

  const handleClear = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
    }
    onChange(null);
  };

  return (
    <div className="image-upload-field">
      <label className="image-upload-label">{label}</label>
      <div className="image-upload-preview">
        {preview ? (
          <img src={preview} alt={`${label} preview`} />
        ) : (
          <div className="image-upload-placeholder">
            <div style={{ fontSize: '1.75rem', marginBottom: '0.35rem' }}>📷</div>
            JPG or PNG
          </div>
        )}
      </div>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED_IMAGE_EXTENSIONS}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        <button
          type="button"
          className="btn btn-secondary"
          style={{ padding: '0.55rem 0.85rem', fontSize: '0.82rem' }}
          onClick={() => inputRef.current?.click()}
        >
          {preview ? 'Change Image' : 'Upload Image'}
        </button>
        {preview && (
          <button
            type="button"
            className="btn btn-secondary"
            style={{ padding: '0.55rem 0.85rem', fontSize: '0.82rem' }}
            onClick={handleClear}
          >
            Remove
          </button>
        )}
      </div>
      {error && <span className="image-upload-error">{error}</span>}
    </div>
  );
}

export { validateImageFile };
export default ImageUpload;
